import FileHelper from "@/helpers/utilities/FileHelper";
import Vue from "vue";
import { getDefaultState } from "./state";

export default {
  /**
   * Reset state to default empty state
   * @param { object } state Vuex State
   */
  resetStateData: state => {
    Object.assign(state, getDefaultState());
  },

  //////////////////////// Drive ////////////////////////

  loadDrive: (state, { data }) => {
    data.extension = {
      name: "Folder",
      icon: ["fas", "folder"],
      color: "#ffda6a"
    };
    data.isFolder = true;
    data.children = FileHelper.addExtensionsToArrayOfFiles(data.children);
    data.children = data.children.map(ch => {
      ch.isFolder = Object.prototype.hasOwnProperty.call(ch, "folder");
      return ch;
    });

    if (!state.driveMap[data.parentReference.driveId]) {
      state.driveMap[data.parentReference.driveId] = {};
    }
    state.driveMap[data.parentReference.driveId][data.id] = data;

    Vue.set(state, "driveMap", Object.assign({}, state.driveMap));
    Vue.set(state.driveRootItemIdMap, data.parentReference.driveId, data.id);
  },

  loadMyOneDriveRoot: (state, myDriveRootId) => {
    state.myDriveRootId = myDriveRootId;
  },

  setDriveRoot: (state, { driveId, itemId }) => {
    Vue.set(state.driveRootItemIdMap, driveId, itemId);
  },

  setDriveRootDisplayName: (state, { driveId, displayName }) => {
    Vue.set(state.driveRootDisplayNameMap, driveId, displayName);
  },

  //////////////////////// DriveItems ////////////////////////

  loadDriveItem: (state, driveItem) => {
    if (!state.driveMap[driveItem.parentReference.driveId]) {
      state.driveMap[driveItem.parentReference.driveId] = {};
    }

    const mapToPersist = Object.assign({}, state.driveMap);
    mapToPersist[driveItem.parentReference.driveId][driveItem.id] = driveItem;

    Vue.set(state, "driveMap", mapToPersist);
  },

  loadBreadCrumbDriveItem: (state, { data }) => {
    if (!state.driveBreadCrumbMap[data.parentReference.driveId]) {
      state.driveBreadCrumbMap[data.parentReference.driveId] = {};
    }

    const mapToPersist = Object.assign({}, state.driveBreadCrumbMap);
    mapToPersist[data.parentReference.driveId][data.id] = data;

    Vue.set(state, "driveBreadCrumbMap", mapToPersist);
  },

  setSectionDriveRoot: (state, { sectionId, driveId, itemId }) => {
    Vue.set(state.sectionRootDriveSettingMap, sectionId, { driveId, itemId });
  },

  loadDriveItemsSharedWithMe: (state, data) => {
    state.driveItemsSharedWithMe = FileHelper.addExtensionsToArrayOfFiles(data);
  },

  //////////////////////// Search ////////////////////////

  search: (state, { driveId, itemId, searchTerm, searchResults }) => {
    const driveIdOrWorld = driveId || "world";

    Vue.set(state.searchSetMap, driveIdOrWorld, { searchTerm, itemId, searchResults });
  }
};
